import { useTranslation } from 'react-i18next'

import Text from '../../../Text'

import * as styles from './CalendarGridMonthHead.module.css'

function CalendarGridMonthHead({ weekdays }) {
  const { t } = useTranslation()

  return (
    <div className={styles.CalendarGridMonthHead}>
      <Text isSecondary className={styles.weekday}>
        {t('Calendar.WeekNumberShortKey')}
      </Text>
      {weekdays.map(weekday => (
        <Text isSecondary className={styles.weekday} key={weekday}>
          {weekday}
        </Text>
      ))}
    </div>
  )
}

export default CalendarGridMonthHead
